import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/ship/shipInstance/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/ship/shipInstance',
    method: 'post',
    data
  })
}
export function addByShipxy(data) {
  return request({
    url: '/api/ship/shipInstance/shipxy',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/ship/shipInstance',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/ship/shipInstance/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/ship/shipInstance',
    method: 'get',
    params: {
      id
    }
  })
}

export function getMmsiById(id) {
  return request({
    url: '/api/ship/shipInstance/getMmsiById',
    method: 'get',
    params: {
      id
    }
  })
}

export function getMmsisByIds(ids) {
  return request({
    url: '/api/ship/shipInstance/getMmsisByIds',
    method: 'get',
    params: {
      ids
    }
  })
}
export function listBankAccount(shipId) {
  return request({
    url: '/api/ship/shipInstance/listBankAccount',
    method: 'get',
    params: {
      shipId
    }
  })
}